import { AfterViewInit, Component, ElementRef, inject, viewChild } from '@angular/core';

import { ModalService } from '../../../services';
import { BackButtonComponent } from '../../back-button/back-button.component';

/** What the user chose on the Save / Discard / Cancel prompt. */
export type SaveDiscardCancelChoice = 'save' | 'discard' | 'cancel';

/**
 * The three-way twin of DiscardChangesModalComponent, for moving BETWEEN records without
 * leaving the screen (Previous / Next on a line editor): the user may want the edit kept,
 * not just thrown away. Closes with the choice; Back dismisses, which callers treat as Cancel.
 */
@Component({
  selector: 'app-save-discard-cancel-modal',
  templateUrl: './save-discard-cancel-modal.component.html',
  styleUrl: './save-discard-cancel-modal.component.scss',
  imports: [BackButtonComponent],
})
export class SaveDiscardCancelModalComponent implements AfterViewInit {
  private readonly modalService = inject(ModalService);

  private readonly focus = viewChild<ElementRef<HTMLButtonElement>>('focus');

  ngAfterViewInit(): void {
    this.focus().nativeElement.focus();
  }

  onSave() {
    this.close('save');
  }

  onDiscard() {
    this.close('discard');
  }

  onCancel() {
    this.close('cancel');
  }

  back() {
    this.modalService.dismiss();
  }

  private close(choice: SaveDiscardCancelChoice) {
    this.modalService.close(choice);
  }
}
